<template>
    <div class="d-inline" v-if="product_configurator_id === 1">
        <button class="btn btn-sm" :class="button_class" @click.prevent="getTenderText(planning_id)">
            <i class="fas fa-download"></i> {{ button_text ? button_text : $t('Tender text') }}
        </button>
        <div class="alert alert-danger" v-if="errors">
            {{ errors }}
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapState } from 'vuex';

    export default {
        props: [
            'planning_id',
            'planning_data',
            'product_configurator_id',
            'button_class',
            'button_text'
        ],
        data() {
            return {
                errors: null,
            }
        },

        methods: {

            getTenderText(planningId) {
                let text = '';
                let queryString = Object.keys(this.planning_data).map(key => key + '=' + this.planning_data[key]).join('&');
                this.$emit('update-loading', true);
                axios.get('/api/plannings/get_luminaire_line_tender_text?product_configurator_id=' + this.product_configurator_id + '&planning_id=' + planningId + (planningId === 0 ? '&' + queryString : ''))
                    .then(response => {
                        text = response.data;
                        this.downloadTenderText(text);
                        this.$emit('update-loading', false);
                    }).catch(error => {
                    if (error.response.status === 401) {
                        this.errors = error.response.data.error;
                    } else {
                        this.errors = this.$t('There was an error');
                    }
                        this.$emit('update-loading', false);
                });

            },

            downloadTenderText(text) {
                let fileURL = window.URL.createObjectURL(new Blob([text]));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', (this.generatedSku ? this.$t('Tender') + '_tempLED_RayLine-' + this.generatedSku : this.$t('Tender') + '_tempLED_RayLine') + '.txt');
                document.body.appendChild(fileLink);

                fileLink.click();
            },

        },

        computed: {

            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                permissions: 'auth/permissions'
            }),
        },

    }
</script>
